export const USER_TEST_SECTIONS = {
    OVERVIEW: { key: 'overview', text: 'overview', value: 'overview' },
    INSTRUCTIONS: { key: 'instructions', text: 'instructions', value: 'instructions' },
    RESULTS: { key: 'results', text: 'past results', value: 'results' },
    RATING: { key: 'rating', text: 'rating', value: 'rating' },
    // QUESTIONS: { key: 'questions', text: 'questions', value: 'questions' },
}